// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import React from 'react';
import { AccountLookUpViewModel } from '../../ViewModels/AccountLookUpViewModel';
import { LookUp } from './LookUp';
import LinkForAccount1 from '@styles/webdesktop/Icons/linkForAccount1.svg';
export class AccountLookUp extends LookUp {
    constructor(props) {
        super(props, AccountLookUpViewModel);
        this.cssClass = 'js-tercera-lookup account-lookup';
        this.btnClass = 'js-lookup-showAcc';
    }
}
AccountLookUp.defaultProps = Object.assign(Object.assign({}, LookUp.defaultProps), { showMAM: false, btnImage: React.createElement(LinkForAccount1, null) });
